import React from "react";
import { Shield, Sparkles, Heart, Award } from "lucide-react";

const AboutFeatures = () => {
  const features = [
    {
      icon: Shield,
      title: "100% Hallmarked",
      description: "Every gold piece is BIS hallmarked, ensuring guaranteed purity and authenticity."
    },
    {
      icon: Sparkles,
      title: "Certified Diamonds",
      description: "All our diamonds come with international certification from trusted laboratories."
    },
    {
      icon: Heart,
      title: "Artisan Craftsmanship",
      description: "Handcrafted by skilled artisans using techniques passed down through generations."
    },
    {
      icon: Award,
      title: "Fair & Transparent",
      description: "Honest pricing with no hidden charges. What you see is what you get."
    }
  ];

  return (
    <section className="bg-white py-24 px-6 md:px-16 lg:px-24 text-center">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-serif text-[#D4AF37] mb-16">
          What Sets Us Apart
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white p-10 rounded-lg shadow-lg border border-gray-100 hover:-translate-y-2 transition-transform duration-300">
              <div className="w-16 h-16 bg-[#fdfaf5] rounded-full flex items-center justify-center mb-8 mx-auto">
                <feature.icon className="text-[#D4AF37]" size={32} />
              </div>
              <h3 className="text-xl font-bold text-[#3B291A] mb-4 uppercase tracking-wider uppercase">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-[15px] leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutFeatures;
